import { classes } from '~utils/Classes';

export const sanitizeInventoryStatus = (inventoryStatus?: string): string => {
    return inventoryStatus 
        ? classes(`status-${inventoryStatus.replace(/\s/g, '-').toLowerCase()}`)
        : '';
};